/**
 * Initialize sidebar from provided config.
 * Sets active state based on current URL path or controller path.
 *
 * Items can use either:
 * - `activeUrl` — matches against window.location.pathname (preferred, URL-based)
 * - `activeExact` — when true, activeUrl uses exact match instead of startsWith
 * - `activePath` — matches against store.currentPath (legacy, controller-based)
 *
 * @param {Object} store - Global store instance
 * @param {Object} config - Sidebar config with items array
 */
export default function initSidebar(store, config) {
  if (!config) return

  const currentUrl = window.location.pathname

  store.sidebar = {
    items: config.items.map((item) => ({
      ...item,
      active: isItemActive(currentUrl, store.currentPath, item)
    }))
  }
}

function isItemActive(currentUrl, currentPath, item) {
  if (item.activeUrl) {
    return item.activeExact ?
      currentUrl === item.activeUrl :
      currentUrl.startsWith(item.activeUrl)
  }

  if (item.activePath && currentPath) {
    return currentPath.startsWith(item.activePath)
  }

  return false
}
